// extracted by mini-css-extract-plugin
export default {"articleBody":"ArticleBody_articleBody__1Nl6L","articleImage":"ArticleBody_articleImage__eeVz4","articleLink":"ArticleBody_articleLink__PD1HJ"};